module.exports = __webpack_public_path__ + "static/media/ownershipimage.23c362c1.png";